import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pos-ui/pos-ui/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/screens/Login/Login.tsx");
